export const LOOKUP_EMAIL_NO_ACCOUNT = 'LOOKUP_EMAIL_NO_ACCOUNT'
export const LOOKUP_EMAIL_ID_EXISTS = 'LOOKUP_EMAIL_ID_EXISTS'
export const LOOKUP_EMAIL_ACCOUNT_FOUND = 'LOOKUP_EMAIL_ACCOUNT_FOUND'
export const LOOKUP_EMAIL_ADD_NAME = 'LOOKUP_EMAIL_ADD_NAME'
export const LOOKUP_EMAIL_ERROR = 'LOOKUP_EMAIL_ERROR'
export const LOOKUP_EMAIL_ACCOUNT_SUSPENDED = 'LOOKUP_EMAIL_ACCOUNT_SUSPENDED'
export const RESET_EMAIL_LOOKUP_DATA = 'RESET_EMAIL_LOOKUP_DATA'
